import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getInstructorsAll, sendBulkEmails } from '../../apis/services';
import { InputSwitch } from "primereact/inputswitch";
import { Modal } from 'react-bootstrap';
import { FilterMatchMode } from 'primereact/api';
import Select from 'react-select';
import FroalaEditor from 'react-froala-wysiwyg';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.css';
import 'froala-editor/js/plugins.pkgd.min.js';
import { Toast } from 'primereact/toast';
const Instructors = () => {
    const { t } = useTranslation();
    const toast = useRef();
    const [ins, setIns] = useState([]);
    const [selectedIns, setSelectedIns] = useState([]);
    const [showModal, setShowModal] = useState({ show: false, item: {} });
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [action, setAction] = useState();
    const [showMailEditor, setShowMailEditor] = useState(false);
    const [mailContent, setMailContent] = useState('TA-PAL');
    const [mailSubject, setMailSubject] = useState('TA-PAL');
    let actionOptions = [
        {
            value: 'send_mail',
            label: t('send_mail')
        },
        // {
        //     value: '',
        //     label: t('delete_selected')
        // }
    ];
    useEffect(() => {
        loadInstructors();
    }, []);
    const loadInstructors = async () => {
        try {
            const res = await getInstructorsAll();
            setIns(res.data.instructors);
        } catch (error) {

        }
    }
    const handleInstructorsBulkAction = () => {
        setShowMailEditor(true);

    }

    const handleSendBulkEmail = async () => {
        try {
            let mails = selectedIns.map((e) => e.instructor.email);
            let data = {
                emails: mails,
                mailContent: mailContent,
                mailSubject: mailSubject
            }
            await sendBulkEmails(data);
            setShowMailEditor(false);
            toast.current.show({ severity: 'success', summary: t('success'), detail: t('emails_added_broadcast_list'), life: 3000 });

        } catch (error) {
            console.log(error);

        }
    }
    return (
        <div className="p-3 glass-card">
            <Toast ref={toast} />
            <div className="d-flex jcsb">
                <div className='mt-2 mb-2'>
                    <h4>{t('manage_instructors')}</h4>
                </div>
            </div>
            <Modal
                show={showMailEditor}
                size='xl'
            >
                <div className="p-3">
                    <div className="form-group mb-2">
                        <label htmlFor="subject" className='mb-1 required'>{t('subject')}</label>
                        <input type="text" name='subject' className='form-control'
                            value={mailSubject}
                            onChange={(e) => {
                                setMailSubject(e.target.value);
                            }}
                        />
                    </div>
                    <FroalaEditor tag='textarea'
                        model={mailContent}
                        onModelChange={(model) => {
                            setMailContent(model);
                        }}
                        config={{
                            placeholderText: t('enter_email'),
                            charCounterCount: true,
                            height: 500,
                            fontSize: ["8", "10", "12", "14", "18", "24", "30", "36", "48"],
                            pluginsEnabled: ["fontSize","colors","emoticons","align", "charCounter", "codeBeautifier",'codeView','fullscreen','lineBreaker','link','lists','paragraphFormat','paragraphStyle','table','entities'],
                        }}
                    />
                </div>
                <div className='m-3'>
                    <Button label={t('send_mail')} className='mx-2'
                        onClick={() => {
                            handleSendBulkEmail();
                        }}
                    />
                    <Button label={t('cancel')} outlined severity='danger'
                        onClick={() => {
                            setShowMailEditor(false);
                        }}
                    />
                </div>
            </Modal>
            <Modal
                show={showModal.show}
            >
                <div className="p-3">
                    <div className="d-flex jcsb aic">
                        <h5>{t('colleges')}</h5>
                        <Button className='icon-btn'
                            onClick={() => {
                                setShowModal({ show: false, item: '' });
                            }}
                        >
                            <span className="material-symbols-outlined">
                                close
                            </span>
                        </Button>
                    </div>
                    <hr />
                    {
                        showModal.item?.colleges?.map((c, index) => {
                            return (
                                <h6 key={c.id}>{c.name}</h6>
                            );
                        })
                    }
                    <hr />
                    <h5>{t('subjects')}</h5>
                    <hr />
                    {
                        showModal.item?.subjects?.map((c, index) => {
                            return (
                                <h6 key={c.id}>{c.name}</h6>
                            );
                        })
                    }
                </div>
            </Modal>
            <div className="data-table mt-2">
                <DataTable
                    // onCellClick={(cell) => {
                    //     navigator.clipboard.writeText(cell.value);
                    // }}
                    value={ins}
                    filters={filters}
                    paginator
                    rows={10}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[10, 25, 50]}
                    dataKey="instructor.id"
                    selectionMode="checkbox"
                    filterDisplay="menu"
                    emptyMessage={t('data_not_available')}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    cellSelection
                    selection={selectedIns}
                    onSelectionChange={(e) => {
                        setSelectedIns(e.value);
                    }}
                    header={
                        <div className='row'>
                            <div className="col-md-6">
                                <input className='form-control'
                                    placeholder={t('search')}
                                    onChange={(e) => {
                                        let _filters = { ...filters };
                                        _filters['global'].value = e.target.value;
                                        setFilters(_filters);
                                    }}
                                />
                            </div>
                        </div>
                    }
                    footer={
                        <form action=""
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleInstructorsBulkAction();
                            }}
                        >
                            <div className='row'>
                                <div className="col-md-4">
                                    <Select className='pr-input' required options={actionOptions}
                                        onChange={(e) => {
                                            setAction(e)
                                        }}
                                        placeholder={t('select')}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <Button label={t('apply')} type='submit' />
                                </div>
                            </div>
                        </form>
                    }
                >
                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    <Column
                        field="instructor.code"
                        header={t('code')}
                        sortable
                    />
                    <Column
                        field="instructor.alias_name"
                        header={t('alias_name')}
                        sortable
                    />
                    <Column
                        field="instructor.email"
                        header={t('email')}
                        sortable
                    />
                    <Column
                        field="instructor.phone"
                        header={t('phone')}
                        sortable
                    />
                    <Column
                        field="instructor.service_charge"
                        header={t('service_charge')}
                        body={(r) => {
                            return (
                                <span>{r.instructor.service_charge}%</span>
                            );
                        }}
                        sortable
                    />
                    <Column
                        field="instructor.rating"
                        header={t('rating')}
                        sortable
                    />
                    <Column
                        field="instructor.active"
                        header={t('status')}
                        body={(row) => {
                            return (
                                <InputSwitch checked={row.instructor.active === 1 ? true : false} />
                            )
                        }}
                        sortable
                    />
                    <Column
                        header={t('actions')}
                        body={(row) => {
                            return (
                                <div className='d-flex'>
                                    <Button className='icon-btn' severity='info'
                                        onClick={() => {
                                            setShowModal({ show: true, item: row });
                                        }}
                                    >
                                        <span className="material-symbols-outlined">
                                            menu_book
                                        </span>
                                    </Button>
                                    <Link
                                        state={JSON.stringify(row.instructor)}
                                        to='/instructors/view'
                                        className='link-icon-btn mx-1' severity='primary' id="edit-btn">
                                        <span className="material-symbols-outlined">
                                            visibility
                                        </span>
                                    </Link>
                                </div>
                            );
                        }}
                    />
                </DataTable>

            </div>
        </div>
    );
}

export default Instructors;